<dropdown-classroom class="noprint"></dropdown-classroom>
<div class="container-fluid">
	<student-list class="row justify-content-center noprint"></student-list>
	<div class="row justify-content-center" id="student-page-content">
		<div class="col-lg-6 mt-1 p-1" id="student-page-column-left">
			<div class="card p-4">
				<student-card class="noprint"></student-card>
				<app-test-window class="noprint"></app-test-window>
				<app-test-history-all></app-test-history-all>
			</div>
		</div>
		<div class="col-lg-6 mt-1 p-1" id="student-page-column-right">
			<div class="card p-4">
				<app-time-graph id="app-time-graph"></app-time-graph>
			</div>
			<div class="card p-4">
				<child-notes></child-notes>
			</div>
			<div style="height: 4%"></div>
		</div>
	</div>
</div>
